/* eslint-disable react/button-has-type */
import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import FactoryIcon from '@mui/icons-material/Factory';
import { Box, Stack, AppBar, Toolbar, IconButton, Typography, Divider, Grid, Paper } from '@mui/material';
import useResponsive from '../../../hooks/useResponsive';
// utils
import { bgBlur } from '../../../utils/cssStyles';
// components
import logoImage from '../../../media/corporate.png';
import Iconify from '../../../components/iconify';
import headerLogoImage from '../../../media/login/logo.png';
//
import AccountPopover from './AccountPopover';
import './animation.css';
// ----------------------------------------------------------------------

const NAV_WIDTH = 250;
const HEADER_MOBILE = 64;
const HEADER_DESKTOP = 92;

const StyledRoot = styled(AppBar)(({ theme, opennav }) => ({
  boxShadow: 'none',
  ...bgBlur({ color: theme.palette.background.default }),
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${opennav ? NAV_WIDTH : 0}px)`, // Adjust width based on sidebar
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme, opennav }) => ({
  minHeight: HEADER_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: HEADER_DESKTOP,
    padding: opennav ? theme.spacing(0, 5) : theme.spacing(0, 8),
    paddingLeft: opennav ? 0 : '50px',
  },
}));

// ----------------------------------------------------------------------

Header.propTypes = {
  onopennav: PropTypes.func,
  opennav: PropTypes.bool,
};

export default function Header({ onopennav, opennav }) {
  const mdUp = useResponsive('up', 'md');

  return (
    <StyledRoot opennav={opennav}>
      <StyledToolbar opennav={opennav}>
        <IconButton
          onClick={onopennav}
          sx={{
            mx: 2,
            color: 'text.primary',
            display: { lg: 'block' },
          }}
        >
          <MenuOpenIcon color="#365486" />
        </IconButton>
        {opennav ? (
          <>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container width={'100%'}>
                <Grid item xs={4} component={Paper} sx={{ backgroundColor: 'inherit', p: 1 }} elevation={0}>
                  <Grid container>
                    <Grid item xs={2} justifyContent={'center'} alignItems={'center'}>
                      <Stack justifyContent={'center'} alignItems={'center'} width={'100%'}>
                        <img
                          src={logoImage}
                          style={{
                            objectFit: 'contain',
                            maxWidth: '50px',
                            margin: '0 20px 0 10px',
                          }}
                          alt="TCMS logo"
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={10} justifyContent={'center'} alignItems={'center'}>
                      <Stack
                        justifyContent={'center'}
                        alignItems={'flex- start'}
                        width={'100%'}
                        height={'100%'}
                        sx={{ borderLeft: '1px solid #C1D8C3' }}
                        pl={1}
                        ml={1}
                      >
                        <Typography
                          variant="body2"
                          textAlign={'left'}
                          className="font_style_headerer2"
                          style={{ textTransform: 'uppercase', color: '#7C93C3' }}
                        >
                          {/* {sessionStorage.getItem('FiscalYear') === null
                            ? `${sessionStorage.getItem('CompanyName')} | ${sessionStorage.getItem('FiscalYear')}`
                            : sessionStorage.getItem('CompanyName')} */}
                            {`${sessionStorage.getItem('CompanyName')}`}
                        </Typography>
                        {/* {sessionStorage.getItem('userRole') !== 'Customer' && ( */}
                          <Typography
                            variant="caption "
                            textAlign={'left'}
                            style={{ color: '#7C93C3' }}
                            className="font_style_branch"
                          >
                            {/* {` Branch : ${sessionStorage.getItem('Branch_Name')} | 🌏 ${sessionStorage.getItem(
                              'Origin'
                            )}  `} */}
                            {`🌏 ${sessionStorage.getItem(
                              'countryName'
                            )}  `}
                          </Typography>
                        {/* )} */}
                      </Stack>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={8} />
              </Grid>
            </Box>
          </>
        ) : (
          <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
            <button
              onClick={() => {
                console.log('Clicked on the logo');
              }}
              style={{
                border: 'none',
                background: 'none',
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <img
                src={headerLogoImage}
                style={{
                  objectFit: 'contain',
                  width: '100px',
                  borderRadius: '10px',
                }}
                alt="TCMS logo"
              />
            </button>
          </Box>
        )}

        <Stack
          direction="row"
          alignItems="center"
          spacing={{
            xs: 0.5,
            sm: 1,
          }}
        >
          <AccountPopover />
        </Stack>
      </StyledToolbar>
      {!opennav && <Divider />}
    </StyledRoot>
  );
}
